









import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import CalculateStore from '@/stores/CalculateStore'

@Component
export default class DimensionsField extends Vue {
  dimensions = ''

  onInput(value: string) {
    const values = (value.match(/\d+(\.\d+)?/g) || []).slice(0, 3)
    this.dimensions = values.join(' ')
  }

  @Watch('dimensions')
  setSizes(value: string) {
    const dimensionsAsArray = value.split(' ').map(size => parseInt(size))

    CalculateStore.setDimensions(dimensionsAsArray)
  }
}
